import { render } from "./topicManager.vue?vue&type=template&id=18a1618d&scoped=true"
import script from "./topicManager.vue?vue&type=script&lang=js"
export * from "./topicManager.vue?vue&type=script&lang=js"

import "./topicManager.vue?vue&type=style&index=0&id=18a1618d&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a1618d"]])

export default __exports__